
const MYMA_GPT_URL = process.env.MYMA_GPT_URL;
const CHAT_API_URL = process.env.REACT_APP_API_URL;
const PARTNER_URL = process.env.REACT_APP_PARTNER_URL;
const BFF_URL = process.env.REACT_APP_BFF_API;

console.log(MYMA_GPT_URL, CHAT_API_URL, PARTNER_URL, BFF_URL);

export const gAPI_THREAD_SUMMARY =`${CHAT_API_URL}/question-query`;

export const gAPI_THREAD_DYNAMIC_SUMMARY =`${CHAT_API_URL}/question-json-query`;

export const gAPI_AZURE_THREAD_DYNAMIC_SUMMARY =`${CHAT_API_URL}/azure-index-query`;

export const gAPI_THREAD_REPLY =`${CHAT_API_URL}/question-query`;


export const pAPI_EMAIL_LOGS =`${CHAT_API_URL}/email-logs`;

export const putAPI_EMAIL_LOGS =`${CHAT_API_URL}/update-email-logs`;

export const post_API_CREATE_TICKET =`${BFF_URL}/public/plugin/ticket`;

export const gAPI_PROPERTY_DETAILS = `${BFF_URL}/public/property/internal`;

export const gAPI_Email_Integrations = `${BFF_URL}/public/integrations/email`;

export const gAPI_QUESTION_SET_DETAILS = `${CHAT_API_URL}/compiled-question-sets`;

export const API_EMAIL_STATS = `${BFF_URL}/public/emailStats`;

export const API_GET_AVAILABILITY = `${PARTNER_URL}/public/availability`;

export const gAPI_ARI_INTEGRATION =  `${CHAT_API_URL}/find-by-property`;

export const gAPI_GROUP_DETAILS =  `${BFF_URL}/public/groups/get`;

export const gAPI_FORMS_CATEGORY =  `${CHAT_API_URL}/forms-category`;

export const gAPI_PROPERTIES =  `${CHAT_API_URL}/properties`;